import { GridRequest } from 'projects/app-core/src/models/gridRequest';

export interface EmailTemplateGridRequest
  extends GridRequest<
    EmailTemplateSort,
    EmailTemplateFilter,
    EmailTemplateSearch,
    EmailTemplateDateFilter
  > {}

export enum EmailTemplateSort {
  CREATED_AT = 'CREATED_AT',
}
export enum EmailTemplateSearch {
  NAME = 'NAME',
}

export enum EmailTemplateDateFilter {
  CREATED_AT = 'CREATED_AT',
}

export enum EmailTemplateFilter {
  TAGS = 'TAGS',
  STATUS = 'STATUS',
  IS_VISIBLE = 'IS_VISIBLE',
}
